"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _cxThemeRegistry = _interopRequireDefault(require("../../CxStyleDictionary/themes/cxThemeRegistry"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Combines the submitted registry with the cxThemeRegistry
 * If the registries parameter is falsy or the registries parameter is empty then return the default cxThemeRegistry
 * @param registries
 */
var mergeRegistry = function mergeRegistry(registries) {
  return registries && registries.length > 0 ? registries.reduce(function (prev, r) {
    return _objectSpread(_objectSpread({}, prev), r);
  }, {}) : _cxThemeRegistry.default;
};

var _default = mergeRegistry;
exports.default = _default;